import './DropdownMenu.css'

import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

const DropdownMenu = ({ className = '', dropdownContent, items }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const calculatePosition = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect()
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      })
    }
  }

  const toggleDropdown = () => {
    if (!isOpen) {
      calculatePosition()
    }
    setIsOpen(!isOpen)
  }

  const onItemClick = item => {
    item.onClick()
    setIsOpen(false)
  }

  const dropdownElement = isOpen && (
    <div
      className='dropdown-content'
      ref={dropdownRef}
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        transform: 'translateX(-100%)',
        zIndex: 1000,
      }}
    >
      {dropdownContent ||
        items.map(({ label, ...rest }, index) => (
          <button key={index} className={`dropdown-item ${rest.className}`} onClick={() => onItemClick(rest)}>
            {label}
          </button>
        ))}
    </div>
  )

  return (
    <div className={`dropdown-menu-container ${className}`}>
      <button className='dropdown-trigger' ref={triggerRef} onClick={toggleDropdown}>
        <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor'>
          <circle cx='12' cy='12' r='1.5' />
          <circle cx='6' cy='12' r='1.5' />
          <circle cx='18' cy='12' r='1.5' />
        </svg>
      </button>
      {isOpen && createPortal(dropdownElement, document.body)}
    </div>
  )
}

export default DropdownMenu
